export const NOTIFICATION = 'notification'